var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":require('@/assets/images/no-data.png'),"alt":"No data"}}),_c('p',[_vm._v(" Sorry currently there is no data! ")])])}
var staticRenderFns = []

export { render, staticRenderFns }